import heic2any from 'heic2any'

class HeicHandler {
  isHeic(filename) {
    if (!filename) return false
    return filename.toLowerCase().endsWith('.heic') || filename.toLowerCase().endsWith('.heif')
  }

  async convert(source) {
    try {
      let blob
      
      if (typeof source === 'string') {
        const response = await fetch(source)
        blob = await response.blob()
      } else {
        blob = source
      }

      const converted = await heic2any({
        blob: blob,
        toType: 'image/jpeg',
        quality: 0.8
      })

      return URL.createObjectURL(converted)
    } catch (error) {
      console.error('HEIC conversion failed:', error)
      return null
    }
  }

  cleanup(url) {
    if (url && url.startsWith('blob:')) {
      URL.revokeObjectURL(url)
    }
  }
}

export default new HeicHandler()